import AssignGroupsPopover from './AssignGroupsPopover'
import enhance from './AssignGroupsPopover.enhancer'

export default enhance(AssignGroupsPopover)



// WEBPACK FOOTER //
// ./src/components/organisms/AssignGroupsPopover/index.js